export var match = function (group, filters) {
    if (filters === void 0) { filters = []; }
    var filterIndex;
    var optionIndex;
    var attributeIndex;
    var selectedOptionIndex;
    var option;
    var filter;
    var attributes = [];
    var selectedOptions;
    var selectedOption;
    var selectedAttribute;
    var intersection;
    var isMatched = true;
    for (filterIndex = 0; filterIndex < filters.length; filterIndex++) {
        if (isMatched === false) {
            break;
        }
        filter = filters[filterIndex];
        selectedOptions = filter.selected();
        if (selectedOptions.length === 0) {
            continue;
        }
        intersection = [];
        for (optionIndex = 0; optionIndex < filter.options.length; optionIndex++) {
            option = filter.options[optionIndex];
            attributes = (group.attributes || []).filter(function (attribute) { return (attribute.key === option.key); });
            for (attributeIndex = 0; attributeIndex < attributes.length; attributeIndex++) {
                for (selectedOptionIndex = 0; selectedOptionIndex < selectedOptions.length; selectedOptionIndex++) {
                    selectedOption = selectedOptions[selectedOptionIndex];
                    selectedAttribute = attributes[attributeIndex];
                    var hasIntersection = intersection.filter(function (x) {
                        return x.key === selectedOption.key && x.valueKey === selectedOption.value;
                    });
                    if (hasIntersection.length > 0) {
                        continue;
                    }
                    if (selectedAttribute.key === selectedOption.key && selectedAttribute.valueKey === selectedOption.value) {
                        intersection.push(selectedAttribute);
                        break;
                    }
                }
            }
        }
        isMatched = isMatched && intersection.length === selectedOptions.length;
    }
    return isMatched;
};
